export default "__VITE_ASSET__D61WLy3i__"